import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";
import { datasetQueryKeys } from "@/shared/domain/datasets/hooks";
import { eventQueryKeys } from "@/shared/domain/events/hooks";
import { fileQueryKeys } from "@/shared/domain/files/hooks";

import { CollectionRecord, UpdateCollectionRequest } from "../CollectionRecord";

import { collectionQueryKeys } from "./collectionQueryKeys";

interface UpdateCollectionVariables {
  collectionId: string;
  resourceOwnerId: string;
  updates: UpdateCollectionRequest;
}

export function useUpdateCollection() {
  const { collections } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<CollectionRecord, Error, UpdateCollectionVariables>({
    mutationFn: ({ collectionId, resourceOwnerId, updates }) =>
      collections.updateCollection(collectionId, updates, { resourceOwnerId }),
    onSuccess: (record) => {
      queryClient.setQueryData(
        collectionQueryKeys.detail(record.collection_id),
        record,
      );

      if (record.resource_type === "dataset") {
        void queryClient.invalidateQueries({
          queryKey: datasetQueryKeys.lists(),
        });
      } else if (record.resource_type === "file") {
        void queryClient.invalidateQueries({
          queryKey: fileQueryKeys.lists(),
        });
      } else if (record.resource_type === "event") {
        void queryClient.invalidateQueries({
          queryKey: eventQueryKeys.listsScope(record.org_id, {
            type: "collection",
            id: record.collection_id,
          }),
        });
      }
    },
  });
}
